module.exports = __webpack_public_path__ + "images/banners/happy-team.376d79d1f27cf97ba4e5.svg";